(function ($) {
    'use strict';
    
    // Wait for the DOM to be ready
    $(document).ready(function () {
        // Wait for the iframe to load
        const iframe = document.querySelector('.newsletter__form iframe');
        if (iframe) {
            iframe.addEventListener('load', function () {
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

                // Check if iframeDocument is available
                if (iframeDocument) {
                    const style = iframeDocument.createElement('style');
                    style.textContent = `
                        .hsfc-Form .hsfc-Heading {
                            color: red;
                        }
                        .hsfc-Form input,
                        .hsfc-Form textarea {
                            width: 100%;
                            padding: 10px;
                            background-color: red;
                            border: 1px solid red;
                            border-radius: 4px;
                        }
                        .hsfc-Form button {
                            background-color: red;
                            color: #fff;
                            padding: 10px 20px;
                            border: none;
                            border-radius: 4px;
                            cursor: pointer;
                        }
                    `;
                    iframeDocument.head.appendChild(style);
                }
            });
        }
    });

})(jQuery);
